<template>
    <div class="nav-bar">
        <div class="nav-bar-toggle" @click="toggleSideBar">
            <i class="far fa-bars"></i>
        </div>
        <div class="nav-bar-brand">
            <router-link :to="{ name: 'dashboard' }">
                <img src="~@/assets/images/logo.svg" alt="1Byte" />
            </router-link>
        </div>
        <div class="d-flex align-items-center">
            <LanguageDropdown class="px-2"></LanguageDropdown>
            <NotificationDropdown class="px-2 mb-1" />
            <b-dropdown v-if="user" right no-caret class="user-dropdown pl-2">
                <template #button-content>
                    <i class="bx bx-user-pin"></i>
                </template>
                <b-dropdown-item :to="{ name: 'profile' }">
                    <img
                        src="@/assets/images/icons/active/user.svg"
                        alt="User"
                    />
                    {{ $t('navbar.profile') }}
                </b-dropdown-item>
                <b-dropdown-item :to="{ name: 'invoices.list' }">
                    <img
                        src="@/assets/images/icons/my-invoice.svg"
                        alt="Invoice"
                    />
                    {{ $t('navbar.invoices') }}
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="logout">
                    <img src="@/assets/images/icons/logout.svg" alt="Logout" />
                    {{ $t('navbar.logout') }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="d-none d-lg-block">
            <UserBalance></UserBalance>
        </div>
    </div>
</template>

<script>
import LanguageDropdown from '@/components/utils/LanguageDropdown/LanguageDropdown';
import { mapState, mapActions } from 'vuex';
import NotificationDropdown from '@/components/utils/NotificationDropdown/NotificationDropdown';
import UserBalance from '@/components/utils/UserBalance/UserBalance';

export default {
    name: 'NavbarShowcase',
    components: { LanguageDropdown, NotificationDropdown, UserBalance },
    computed: {
        ...mapState('auth', ['user']),
    },
    methods: {
        toggleSideBar() {
            this.$store.commit('nav/changeActive');
        },
        ...mapActions('auth', ['logout']),
    },
};
</script>

<style lang="scss" scoped>
@import 'Navbar';
</style>
